<div class="sales-report-header-row">
  <div class="sales-report-header-main">
    <div class="sales-report-header-title-row">
      <h2 class="sales-report-title">
        {{ 'cards.reports.sales_report.title' | translate: { retailer: retailerName } }}
      </h2>
      <span class="sales-report-date-range" *ngIf="dateFrom || dateTo">
        {{ dateFrom | formDate }} - {{ dateTo | formDate }}
      </span>
    </div>
    <span
      class="sales-report-expires"
      [class.sales-report-expires--expired]="isExpired"
      *ngIf="expiresAt"
    >
      <ng-container *ngIf="isExpired; else expiresSoon">
        {{ 'cards.reports.sales_report.expired_notice' | translate:{ date: (deletedAt | formDate: 'L HH:mm') } }}
      </ng-container>
      <ng-template #expiresSoon>
        {{ 'cards.reports.sales_report.expires_at' | translate }}
        {{ expiresAt | formDate: 'L HH:mm' }}
      </ng-template>
    </span>
  </div>

  <div class="sales-report-header-actions">
    <combined-toggle-button
      class="chart-unit-toggle"
      [leftToggled]="chartUnit === SalesReportChartUnit.Piece"
      [rightToggled]="chartUnit === SalesReportChartUnit.Euro"
      (leftClicked)="setChartUnit(SalesReportChartUnit.Piece)"
      (rightClicked)="setChartUnit(SalesReportChartUnit.Euro)"
    >
      <span text1>{{ 'cards.reports.sales_report.chart_unit_piece' | translate }}</span>
      <span text2>{{ 'cards.reports.sales_report.chart_unit_euro' | translate }}</span>
    </combined-toggle-button>

    <button
      type="button"
      class="export-xls-button"
      [title]="'action.download_xls' | translate"
      (click)="exportXls()"
    >
      <span class="excel-icon" aria-hidden="true"></span>
    </button>

    <lxm-button
      *ngIf="canManage"
      type="beige"
      label="cards.reports.sales_report.expand"
      padding="7px 12px"
      (click)="expand.emit()"
    ></lxm-button>
  </div>
</div>

<div class="sales-report-chart" *ngIf="rows.length; else emptyEntries" [class.is-fetching]="isFetching">
  <div class="sales-report-products-col">
    <div class="products-header">
      <button
        type="button"
        class="sort-button"
        [attr.aria-sort]="orderBy === 'name desc' ? 'descending' : 'ascending'"
        (click)="toggleSort()"
      >
        <span [ngClass]="orderBy === 'name desc' ? 'sort-za-icon' : 'sort-az-icon'"></span>
      </button>
    </div>
    <div class="product-row" *ngFor="let row of rows">
      <div class="product-info">
        <image-popover
          *ngIf="row.showImage"
          class="product-image"
          [defaultImageUrlId]="row.id"
        ></image-popover>
        <span class="product-name">{{ row.name }}</span>
      </div>
      <div class="product-meta">
        <div class="product-meta-row" *ngIf="row.ean">
          <span class="product-code">{{ row.ean }}</span>
        </div>
        <div class="product-meta-row" *ngIf="row.gln">
          <span class="product-code">{{ row.gln }}</span>
        </div>
        <div class="product-meta-row" *ngIf="row.code || row.unit">
          <span class="product-code">{{ row.code }}</span>
          <span class="product-unit" *ngIf="row.unit">{{ row.unit }}</span>
        </div>
        <div class="product-categories" *ngIf="row.locationFormat || row.categories.length">
          <span class="product-category" *ngIf="row.locationFormat">
            {{ row.locationFormat | translatedValue: false : '' }}
          </span>
          <span class="product-category" *ngFor="let category of row.categories">
            {{ category }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="sales-report-days-col" (mouseleave)="hideTooltip()">
    <div class="days-header">
      <div class="days-header-main">
        <div class="months-row">
          <div class="month-cell" *ngFor="let day of days">
            <span class="month-label" *ngIf="day.showMonth">{{ day.monthLabel }}</span>
          </div>
        </div>
        <div class="numbers-row">
          <div
            class="day-header"
            *ngFor="let day of days; let i = index"
            [class.day-header--today]="day.isToday"
            [class.day-header--hover]="hoveredDayIndex === i"
          >
            {{ day.label }}
          </div>
        </div>
      </div>
      <div class="chart-scale-spacer" aria-hidden="true"></div>
    </div>
    <div class="chart-row" *ngFor="let row of rows">
      <div class="chart-grid" aria-hidden="true">
        <span
          class="chart-grid-line"
          *ngFor="let tick of row.scaleTicks; let i = index"
          [style.top.%]="scaleTickPercent(i)"
        ></span>
      </div>
      <div class="chart-days">
        <div
          class="day-cell"
          *ngFor="let day of row.dayValues; let i = index"
          [class.day-cell--hover]="hoveredDayIndex === i"
          (mouseenter)="showDayTooltip($event, row, i)"
          (mousemove)="showDayTooltip($event, row, i)"
        >
          <div class="bars" [class.bars--vertical]="days.length >= 22 && showSales && showInventory">
            <div class="bar-col" *ngIf="showSales">
              <!-- <span class="bar-value">{{ day.salesLabel }}</span> -->
              <span class="bar bar--sales" [style.height.px]="day.salesHeight"></span>
            </div>
            <div class="bar-col" *ngIf="showInventory">
              <!-- <span class="bar-value">{{ day.inventoryLabel }}</span> -->
              <span class="bar bar--inventory" [style.height.px]="day.inventoryHeight"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-scale">
        <div class="chart-scale-plot">
          <span
            class="chart-scale-tick"
            *ngFor="let tick of row.scaleTicks; let i = index"
            [style.top.%]="scaleTickPercent(i)"
          >
            {{ formatScaleTick(tick) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyEntries>
  <no-content
    *ngIf="!isFetching"
    image="no-report-data"
    [heading]="emptyHeadingKey"
    text="cards.reports.sales_report.no_entries_text"
  ></no-content>
</ng-template>

<div class="sales-report-footer" *ngIf="count">
  <mat-paginator
    [length]="count"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="onPage($event)"
  ></mat-paginator>
</div>

<div
  class="sales-report-day-tooltip"
  *ngIf="tooltip.visible"
  [class.sales-report-day-tooltip--above]="tooltip.above"
  [style.left.px]="tooltip.left"
  [style.top.px]="tooltip.top"
  [style.--tooltip-arrow-left.px]="tooltip.arrowLeft"
>
  <div class="tooltip-header">
    {{ tooltip.dateLabel }}
  </div>

  <div class="tooltip-block" *ngIf="showSales">
    <div class="tooltip-row" *ngIf="showAveragePrice">
      <span class="tooltip-row-start">
        <span class="report-sales-icon" aria-hidden="true"></span>
        <span>{{ 'cards.reports.sales_report.average_price' | translate }}</span>
      </span>
      <span class="tooltip-value tooltip-value--medium">
        {{ tooltip.averagePrice | priceValue: 3 }}
      </span>
    </div>
    <div class="tooltip-row">
      <span class="tooltip-label--medium">
        {{ 'cards.reports.sales_report.sold' | translate }}
      </span>
      <span>
        {{ tooltip.sold }}
        <ng-container *ngIf="tooltip.unit">{{ tooltip.unit }}</ng-container>
        <ng-container *ngIf="!tooltip.unit && isProductView">{{
          'cards.reports.sales_report.unit_piece' | translate
        }}</ng-container>
      </span>
    </div>
    <div class="tooltip-row">
      <span class="tooltip-label--medium">
        {{ 'cards.reports.sales_report.total_revenue' | translate }}
      </span>
      <span>{{ tooltip.revenue | priceValue: 3 }}</span>
    </div>
  </div>

  <div class="tooltip-block" *ngIf="showInventory">
    <div class="tooltip-row">
      <span class="tooltip-row-start">
        <span class="report-inventory-icon" aria-hidden="true"></span>
        <span>{{ 'cards.reports.sales_report_search.inventory' | translate }}</span>
      </span>
      <span class="tooltip-value tooltip-value--inventory">
        {{ tooltip.inventory }}
        <ng-container *ngIf="tooltip.unit">{{ tooltip.unit }}</ng-container>
        <ng-container *ngIf="!tooltip.unit && isProductView">{{
          'cards.reports.sales_report.unit_piece' | translate
        }}</ng-container>
      </span>
    </div>
  </div>
</div>

<a class="no-display" #download></a>
